var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9004 17L5.40039 4.5M9.40039 9.45131C9.08921 9.79438 8.90039 10.245 8.90039 10.7386C8.90039 11.8134 9.79582 12.6847 10.9004 12.6847C11.4097 12.6847 11.8745 12.4995 12.2276 12.1945M17.9327 12.6847C18.6212 11.654 18.9004 10.8134 18.9004 10.8134C18.9004 10.8134 17.0799 5 10.9004 5C10.5535 5 10.2203 5.01832 9.90039 5.05291M15.4004 15.2079C14.2525 15.9401 12.7748 16.4579 10.9004 16.4273C4.79783 16.3275 2.90039 10.8134 2.90039 10.8134C2.90039 10.8134 3.78194 7.9984 6.40039 6.2861",
    stroke: "#A9A9AE",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClose);
export default __webpack_public_path__ + "static/media/eye-close.cd1713e8219c70cff3319598c535bee7.svg";
export { ForwardRef as ReactComponent };